import { Injectable } from '@angular/core';
import { OAuthProvider } from './model/o-auth-provider';

@Injectable({
  providedIn: 'root'
})
export class OAuthProviderService {
  formatProvider(provider: OAuthProvider | null): string {
    switch (provider) {
      case 'FACEBOOK':
        return 'Facebook';
      case 'MICROSOFT':
        return 'Microsoft';
      case 'GOOGLE':
        return 'Google';
      case 'GITHUB':
        return 'GitHub';
      case 'LINKEDIN':
        return 'LinkedIn';
      case 'APPLE':
        return 'Apple';
      default:
        return '';
    }
  }
}
